export class ReferenceData {
    public Id: string;
    public Name: string;
    public Status: boolean;
}